import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { jackpotSchema } from '../types';

export type EditJackpotMutationParams = {
	id: number;
	betRate: number;
	initialAmount: number;
	limitAmount: number;
};

export const createEditJackpotMutation = () =>
	createAuthMutation({
		params: declareParams<EditJackpotMutationParams>(),
		request: {
			method: 'PATCH',
			url: ({ id }) => `/jackpot/${id}`,
			body: ({ id, ...params }) => params,
		},
		response: {
			contract: zodContract(jackpotSchema),
		},
	});
